import React from 'react';
import {UserContextType} from 'components/triggers/UserContextType';

export default class UserIsSharedMeConditionComponent extends React.Component {
  render() {
    const {contextType} = this.props;
    return (
      <div>
        {contextType === UserContextType.USER && (
          <span>
            <span className="condition-action" onClick={this.props.onClick}>
              [I or users who have this rule enabled]
            </span>{' '}
            review a call
          </span>
        )}
        {contextType === UserContextType.CALLER && (
          <span>
            is from{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              [me or a user that has this rule enabled]
            </span>
          </span>
        )}
        {contextType === UserContextType.CALL && (
          <span>
            the caller is{' '}
            <span className="condition-action " onClick={this.props.onClick}>
              [me or a user that has this rule enabled]{' '}
            </span>
          </span>
        )}
      </div>
    );
  }
}
